<template>
  <wrapper-edit
    :wrapper-width="wrapperWidth"
    @back="paasPageBack"
    wTitle="商品属性配置页面">
  <div id="store-attr" class="mp-form" v-cloak="" slot="form">
    <Form :label-width="80" style="width: 100%" v-show="hidden === false">
      <FormItem>
        <Row>
          <Col span="5">
            <Button type="dashed" long @click="hiddenBool" icon="plus-round">添加新规则</Button>
          </Col>
        </Row>
      </FormItem>
    </Form>
    <Form :label-width="80" style="width: 100%" v-show="hidden === true">
      <FormItem
        :label="'规则名称:'">
        <Row>
          <Col style="position: relative;margin-right: 6px"  span="5"
                 v-for="(item, index) in items"
                 :key="index">
            <Input type="text" v-model="item.value" placeholder="设置名称" ></Input>
            <Button class="ghost-button" type="primary" ghost @click="handleRemove(index)"
                    v-show="item.attrHidden === true">
              <Icon type="ios-close" size="24"></Icon>
            </Button>
            <Button class="ghost-button" type="primary" ghost @click="attrHiddenBool(item)"
                    v-show="item.attrHidden === false">
              <Icon type="ios-checkmark" size="24"></Icon>
            </Button>
          </Col>
          <Col span="5">
            <Button type="dashed" long @click="handleAdd" icon="plus-round">添加新规则</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem v-show="item.attrHidden === true"
                 v-for="(item, index) in items"
                 :key="index"
                 :label="''+item.value+':'" >
        <Row>
          <Col span="3"
                 v-for="(attr,k) in item.detail"
                 :key="attr"
                 :name="attr">
            <Tag type="border" closable color="primary" @on-close="attrRemove(item,k)">{{ attr }}</Tag>
          </Col>
          <Col span="5">
            <Input type="text" v-model="item.detailValue" placeholder="设置属性"></Input>
          </Col>
          <Col span="5">
            <Button type="primary" style="margin-left: 6px" @click="attrAdd(item)">添加</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem v-show="hidden === true" style="width: 100%;">
        <Row style="margin: 0 88px 0 20px">
          <Col span="24">
            <Button type="primary" long @click="addGoods(true)">生成</Button>
          </Col>
        </Row>
      </FormItem>

      <template v-if="items.length > 0 && items[0].value!=='' && items[0].detail.length>0 && attrs.length">
        <template v-for="(attr,index) in attrs">
          <FormItem>
            <Row>
              <template v-for="(item,index) in attr.detail">
                <Col span="3" style="margin-right: 2px">
                  {{index}}:{{item}}
                </Col>
              </template>
              <Col span="4">
                <span :class="attr.check ? 'check':''">金额:</span>&nbsp;&nbsp;<Input placeholder="金额" v-model="attr.price" style="width: 60%"
                                                                                      :number="true"></Input>
              </Col>
              <Col span="4">
                <span :class="attr.check ? 'check':''">库存:</span>&nbsp;&nbsp;<Input placeholder="库存" v-model="attr.stock" style="width: 60%"
                                                                                      :number="true"></Input>
              </Col>
              <Col span="4">
                <span :class="attr.check ? 'check':''">成本价:</span>&nbsp;&nbsp;<Input placeholder="成本价" v-model="attr.cost" style="width: 60%"
                                                                                       :number="true"></Input>
              </Col>
              <Col span="2" offset="1" style="margin-right: 2px">
                <div class="demo-upload">
                  <img :src="attr.pic">
                  <div class="demo-upload-cover">
                    <Icon type="ios-eye-outline" @click.native="openPic(attr.pic)" ></Icon>
                    <Icon type="ios-cloud-upload-outline"  @click.native="getAttrPic(index)"></Icon>
                  </div>
                </div>
              </Col>
              <Col span="2" style="margin-right: 3px">
                <Button type="ghost" @click="removeGoods(index)">删除</Button>
              </Col>
            </Row>
          </FormItem>
        </template>
        <FormItem>
          <Row>
            <Col span="2" offset="2">
              <Button type="primary" @click="submit">提交</Button>
            </Col>
            <Col span="2" offset="1">
              <Button type="error" @click="clear">清空所有属性</Button>
            </Col>
          </Row>
        </FormItem>
      </template>
    </Form>
    <Spin fix v-show="submiting === true">保存中...</Spin>
  </div>
  </wrapper-edit>
</template>

<script>
    import wrapperEdit from "@/components/paas/wrapper-edit";
    import metaEdit from "@/assets/js/meta-edit.js";
    export default {
      name: "attr",
      mixins:[metaEdit],
      components:{wrapperEdit},
      data(){
        return{
          wrapperWidth:"80%",
          serviceUrl:"/eb/store/product",  //每个页面访问后台服务器的路径
          currentIdFiledName: 'id',
          items:[{
            value: '',
            detailValue:'',
            attrHidden:false,
            detail:[]
          }],
          hidden:false,
          attrHidden:false,
          submiting :false,
          attrs:[],
        }
      },
      created(){
        this.axios.post(this.$store.state.sysApi+"/eb/store/product/attr/returnProductData?productId="+this.$route.query.id).
        then(res => {
          ;
          if(res.code === 200){
            this.attrs = res.data.attrs;
            if(res.data.items.length > 0 ){
              this.items = res.data.items;
            }
          }
        }).catch(err =>{
          this.$Message.error('数据查询失败，请重试！');
        });
      },
      methods:{
        /**
         * 当没有配置属性时，点击添加规则，隐藏之前的form，显示带有input的form
          */
        hiddenBool(){
          this.hidden = true;
        },
        /**
         * 添加新规则
         */
        handleAdd () {
          if(!this.checkAttr())return ;
          this.items.push({
            value: '',
            detailValue:'',
            attrHidden:false,
            detail:[]
          });
        },
        attrRemove(item,k){
          if(1===item.detail.length){
            this.$Message.error('请设置至少一个属性');
            return false;
          }
          item.detail.splice(k,1);
        },
        /**
         * 删除规格
         * */
        handleRemove (index) {
          if(this.items.length > 1)
            this.items.splice(index,1);
          else
            this.$Message.error('请设置至少一个规则');
        },
        /**
         * 添加规则
         * @param item
         * @returns {boolean}
         */
        attrAdd (item) {
          if(!item.detailValue) return false;
          item.detail.push(item.detailValue);
          item.detailValue = '';
        },
        attrHiddenBool(item){
          if(item.value === ''){
            this.$Message.error('请填写规则名称');
          }else{
            item.attrHidden = true;
          }
        },
        /**
         * 生成
         * @param type
         */
        addGoods(type){
          if(this.attrs.length){
            if(!this.checkGoods())return ;
          }

          let attrDetail = [];
          if(this.items.length > 0){
            let collectArray = [];
            for(let item of this.items){
              let detail = item.detail;
              let detailMapArr = [];
              for(let i = 0; i < detail.length; i++){
                let detailMap = {};
                detailMap[item.value] = detail[i];
                detailMapArr.push(detailMap);
              }
              collectArray.push(detailMapArr);
            }
            attrDetail = this.permutationArray(collectArray);
          }

          let attrValue = [];
          if(attrDetail !== null && attrDetail.length > 0){
            for(let detail of attrDetail){
              let attr = {};
              attr.detail = detail;
              attr.cost = "";
              attr.price = "";
              attr.stock = 0;
              attr.pic = "";
              attr.check = false;
              attrValue.push(attr);
            }
          }
          this.attrs = attrValue;
        },
        /**
         * 预览图片
         * */
        openPic(src){

        },
        /**
         * 打开图片上传页面
         * */
        getAttrPic(index){
          /*this.createFrame('选择图片','/admin/widget.images/index/fodder/'+index+'.html');*/
        },
        /*createFrame:function(title,src,opt){
          opt === undefined && (opt = {});
          let h = parent.document.body.clientHeight - 100;
          return layer.open({
            type: 2,
            title:title,
            area: [(opt.w || 700)+'px', (opt.h || h)+'px'],
            fixed: false, //不固定
            maxmin: true,
            moveOut:false,//true  可以拖出窗外  false 只能在窗内拖
            anim:5,//出场动画 isOutAnim bool 关闭动画
            offset:'auto',//['100px','100px'],//'auto',//初始位置  ['100px','100px'] t[ 上 左]
            shade:0,//遮罩
            resize:true,//是否允许拉伸
            content: src,//内容
            move:'.layui-layer-title'
          });
        },*/
        /**
         * 删除一条数据
         * */
        removeGoods(index){
          this.attrs.splice(index,1);
        },
        /**
         * 保存数据
         * */
        submit(){
          let that = this;
          that.submiting = true;
          if(!this.checkAttr() || !this.checkGoods()){
            that.submiting = false;
            return
          }
          for(let attr in that.attrs){
            that.attrs[attr].check = false;
          }
          let param = {
            productId:this.$route.query.id,
            items:JSON.stringify(that.items),
            attrs:JSON.stringify(that.attrs)
          };
          this.axios.post(this.$store.state.sysApi+"/eb/store/product/attr/saveProductAttrs",param).then((res)=>{
            that.submiting = false;
            if(res.code === 200){
              that.$Message.success('属性配置保存成功!');
              //返回list页面
              this.paasPageBack();
            }else{
              that.$Message.error('属性配置保存失败!');
            }
          }).catch((err)=>{
            that.$Message.error(err);
          })
        },
        clear(){
          let that = this;
          this.$swal({
              title: "您确定要清空产品属性吗",
              text: "删除后将无法恢复，请谨慎操作！",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "是的，我要清空！",
              cancelButtonText: "让我再考虑一下…",
              closeOnConfirm: false,
              closeOnCancel: false
            }).then((isConfirm)=> {
              if(isConfirm.value){
                that.axios.post(this.$store.state.sysApi+"/eb/store/product/attr/deleteProductAttrData?productId="+this.$route.query.id).then((res)=> {
                  if (res.code === 200) {
                    that.$Message.error('清空成功!');
                    window.location.reload();
                  } else {
                    this.$Message.error('清空失败!');
                  }
                }).catch((err)=> {
                  that.$Message.error(err);
                })
              }

            }).catch(console.log);

        },
        checkAttr(){
          let bool = true;
          this.items.map((item)=>{
            if(!bool) return;
            if(!item.value){
              this.$Message.error('请填写规则名称');
              bool = false;
            }else if(!item.detail.length){
              this.$Message.error('请设置规则属性');
              bool = false;
            }
          });
          return bool;
        },
        checkGoods(){
          let bool = true;
          let that = this;
          this.attrs.map((attr)=>{
            if(!bool) return ;
            if(!Object.keys(attr.detail).length){
              that.$Message.error('请选择至少一个属性');
              bool = false;
            }else if(attr.price !== parseFloat(attr.price) || attr.price < 0){
              that.$Message.error('请输入正确的商品价格');
              bool = false;
            }else if(attr.stock !== parseInt(attr.stock) || attr.stock < 0){
              that.$Message.error('请输入正确的商品库存');
              bool = false;
            }
          });
          return bool;
        },
        /**
         * 数组自由组合
         * @param arr
         * @returns {*}
         */
        permutationArray(arr){
          let len = arr.length;
          // 当数组大于等于2个的时候
          if(len >= 2){
            // 第一个数组的长度
            let len1 = arr[0].length;
            // 第二个数组的长度
            let len2 = arr[1].length;
            // 2个数组产生的组合数
            let lenBoth = len1 * len2;
            //  申明一个新数组,做数据暂存
            let items = new Array(lenBoth);
            // 申明新数组的索引
            let index = 0;
            // 2层嵌套循环,将组合放到新数组中
            for(let i=0; i<len1; i++){
              for(let j=0; j<len2; j++){
                let itemMap = {};
                for (let key in arr[0][i]) {
                  itemMap[key] = arr[0][i][key];
                }
                for (let key in arr[1][j]) {
                  itemMap[key] = arr[1][j][key];
                }
                items[index] = itemMap;
                index++;
              }
            }
            // 将新组合的数组并到原数组中
            let newArr = new Array(len -1);
            for(let i=2;i<arr.length;i++){
              newArr[i-1] = arr[i];
            }
            newArr[0] = items;
            // 执行回调
            return this.permutationArray(newArr);
          }else{
            return arr[0];
          }
        }
      }
    }
</script>

<style scoped>
.ghost-button{
  position: absolute;
  top:0;
  right:0;
  margin-top:1px;
  border: none;
  font-size: 8px;
  line-height: 1.8
}
/*鼠标点击后的*/
.ghost-button:visited,.ghost-button:active{
  border:none !important;
}
</style>
